import {useState} from 'react'
import {Auth} from 'aws-amplify';
import {SubmitButton, InputBox, Form} from '../../styles/LoginStyle.js'
import {Text,AlertText,PasswordText} from '../../styles/style.js';

export default function NewPassword(props){
    const [newPass,setNewPass] = useState('');
    const [confirmNewPass,setConfirmNewPass] = useState('');
    const [alert,setAlert] = useState(false);
    const [alertMessage,setAlertMessage] = useState('');
    const [passwordError,setPasswordError] = useState(false);

    const updatePassword = event =>{
        event.preventDefault();
		if(newPass !== confirmNewPass){
			setAlert(true)
			setAlertMessage('Password and Confirm Password should be the same')
		}else if(newPass === ''){
			setAlert(true)
			setAlertMessage('Please enter a password')
		}else{
			Auth.completeNewPassword(
				props.user,               
				newPass, 
				{
				  email: props.user.email,
				  name: props.user.name,
				  
				}).then(data =>{
					props.passwordChanged(newPass)
					
				}).catch(error =>{
					if(error.message.includes('Password does not conform to policy')){
						setPasswordError(true)
					}
				})
		}
    }

    return(
        <Form>
            {alert && 
                <AlertText>{alertMessage}</AlertText>
            }

            {passwordError && 
                <>
                    <PasswordText>
                        Please enter a password that follows these guidelines:
                    </PasswordText>
                    <ul>
                        <li><PasswordText>One uppercase letter</PasswordText></li>
                        <li><PasswordText>One lowercase letter</PasswordText></li>
                        <li><PasswordText>One special character</PasswordText></li>
                        <li><PasswordText>One number</PasswordText></li>
                        <li><PasswordText>Must be at least 8 characters long</PasswordText></li>
                    </ul>
                </>
            }

            <Text>Enter your new password:</Text>
            <InputBox 
                placeholder="Password" 
                type='password' 
                name='newPass' 
                value={newPass} 
                onChange={e=>setNewPass(e.target.value)} 
                maxLength='30'>
            </InputBox>
            <InputBox 
                placeholder="Confirm Password" 
                type='password' 
                name='confirmNewPass' 
                value={confirmNewPass} 
                onChange={e=>setConfirmNewPass(e.target.value)} 
                maxLength='30'>
            </InputBox>
            <SubmitButton onClick={updatePassword}>Ok</SubmitButton>
        </Form>
    )
}